import { Box } from '@mui/material';
import PrimaryBtn from 'components/shared/Buttons/PrimaryButton';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useConfirmDialog from '../../hooks/dialogs/useConfirmDialog';
import useUser from '../../hooks/user/useUser';
import useUserSWR from '../../hooks/user/useUserSWR';
import DeleteButton from '../shared/Buttons/DeleteButton';
export const CompanyLogoUpload = () => {
    const noImageUrl = '/assets/no-image_200x.webp';
    const { t } = useTranslation('profile');
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImage, setCurrentImage] = useState(null);
    const logoUrl = process.env.REACT_APP_BACKEND_URL;
    const userApi = useUser();
    const confirmDialog = useConfirmDialog();
    const { user, isLoading, isError, forceRefresh } = useUserSWR();

    useEffect(() => {
        if (user) {
            if (user.logo) {
                setCurrentImage(logoUrl + user.logo);
            }
        }
    }, [user, isLoading]);

    const uploadImage = (file) => {
        if (file) {
            setSelectedImage(file);
        }
    };

    const handleUpload = () => {
        const formData = new FormData();
        formData.append('logo', selectedImage);
        userApi
            .uploadCompanyLogo(formData)
            .then((image) => {
                setCurrentImage(logoUrl + image);
                setSelectedImage(null);
                forceRefresh().then();
            })
            .catch();
    };

    const handleDeleteLogo = () => {
        userApi
            .deleteCompanyLogo()
            .then(() => {
                setCurrentImage(null);
                setSelectedImage(null);
                forceRefresh().then();
            })
            .catch();
    };

    const deleteCurrentLogo = () => {
        confirmDialog.showDialog({
            title: t('PROFILE.COMPANY.DELETE_LOGO_MODAL.TITLE'),
            content: t('PROFILE.COMPANY.DELETE_LOGO_MODAL.CONTENT'),
            confirmText: t('PROFILE.COMPANY.DELETE_LOGO_MODAL.CONFIRM'),
            cancelText: t('PROFILE.COMPANY.DELETE_LOGO_MODAL.CANCEL'),
            onConfirm: () => handleDeleteLogo(),
        });
    };

    return (
        <>
            <Box>
                {(currentImage || selectedImage) && (
                    <div>
                        <img
                            alt="not found"
                            width={'250px'}
                            src={
                                selectedImage
                                    ? URL.createObjectURL(selectedImage)
                                    : currentImage
                                    ? currentImage
                                    : noImageUrl
                            }
                        />
                    </div>
                )}
            </Box>
            <Box>
                <PrimaryBtn variant="contained" component="label">
                    {t('PROFILE.COMPANY.COMPANY_LOGO.BUTTON_SELECT')}
                    <input
                        hidden
                        type="file"
                        accept="image/*"
                        onChange={(event) => {
                            uploadImage(event.target.files[0]);
                        }}
                    />
                </PrimaryBtn>
                {selectedImage && (
                    <>
                        <PrimaryBtn
                            onClick={handleUpload}
                            sx={{ marginLeft: '10px' }}
                        >
                            {t('PROFILE.COMPANY.COMPANY_LOGO.BUTTON_UPLOAD')}
                        </PrimaryBtn>

                        <DeleteButton onClick={() => setSelectedImage(null)}>
                            {t('PROFILE.COMPANY.COMPANY_LOGO.BUTTON_REMOVE')}
                        </DeleteButton>
                    </>
                )}
                {currentImage && !selectedImage && (
                    <DeleteButton onClick={deleteCurrentLogo}>
                        {t('PROFILE.COMPANY.COMPANY_LOGO.BUTTON_REMOVE')}
                    </DeleteButton>
                )}
            </Box>
        </>
    );
};
